import T from "@marginly/ui/components/typography";

import Space from "../../common/space";
import {
  UntilAirdrop,
  UntilBlock,
  UntilGrid,
  UntilGridMobile,
  UntilRow,
  UntilSparks,
  UtilThumb,
} from "../styled";

const TimingSchema = () => {
  return (
    <section>
      <UntilBlock>
        <T headerL>Farm Sparks until Q3&nbsp;2024</T>
        <Space height={12} heightMobile={4} />
        <T body>Marginly offers many ways to earn Sparks</T>
        <Space height={66} heightMobile={32} />
        <UntilGrid>
          <div className="lined">
            <T body>May &apos;24</T>
          </div>
          <div className="lined">
            <T body>June &apos;24</T>
          </div>
          <div className="lined lined-last">
            <T body>Q3 &apos;24</T>
          </div>

          <UntilRow className="liq">
            <UtilThumb>
              <img src="/images/airdrop/deposit-2.svg" alt="" />
            </UtilThumb>
            <T body>Provide Liquidity</T>
          </UntilRow>
          <UntilRow className="leverage">
            <UtilThumb>
              <img src="/images/airdrop/farm.png" alt="" />
            </UtilThumb>
            <T body>Take Leverage on Marginly</T>
          </UntilRow>
          <UntilSparks>
            <div className="row">
              <img src="/images/airdrop/spark-2.svg" alt="" className="spark" />
              <T body>Earn Sparks</T>
            </div>
            <img
              src="/images/airdrop/arrow-right.png"
              alt=""
              className="arrow"
            />
          </UntilSparks>

          <UntilAirdrop>
            <img src="/images/airdrop/airdrop-thumbnail.png" alt="" />
            <T body>Airdrop</T>
          </UntilAirdrop>
        </UntilGrid>

        <UntilGridMobile>
          <UntilRow className="top">
            <UtilThumb>
              <div className="absolute">
                <T body>May &apos;24</T>
              </div>
              <img src="/images/airdrop/deposit-2.svg" alt="" />
            </UtilThumb>
            <T body>Provide Liquidity</T>
          </UntilRow>
          <UntilRow className="mid">
            <UtilThumb>
              <div className="absolute">
                <T body>June &apos;24</T>
              </div>
              <img src="/images/airdrop/farm.png" alt="" />
            </UtilThumb>
            <T body>Take Leverage</T>
          </UntilRow>
          <UntilRow className="bot">
            <UtilThumb className="airdrop">
              <div className="absolute">
                <T body>Q3 &apos;24</T>
              </div>
              <img src="/images/airdrop/airdrop-thumbnail.png" alt="" />
            </UtilThumb>
            <T body>Airdrop</T>
          </UntilRow>
        </UntilGridMobile>
      </UntilBlock>
    </section>
  );
};

export default TimingSchema;
